import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import oluseun from "../../../assets/images/oluseun.jpg";
import katja from "../../../assets/images/katja.jpg";
import saratu from "../../../assets/images/saratu.jpg";

const council = [
  {
    name: "Oluseun Onigbinde",
    title: "Fund Lead and Co-founder, BudgIT Foundation",
    profile:
      "Oluseun Onigbinde is an award-winning public data visualization expert and open government advocate and co-founder of BudgIT, the leading fiscal transparency & data visualization organization in Nigeria. Since 2011, he has worked to strengthen fiscal transparency in Nigeria, building a reputation for public sector efficiency. His organization has reached over 12 million Nigerians and also support over 45 civil society organizations and public institutions such as NEITI, National Assembly, Nigerian Investment Promotion Commission and Kaduna State Government. Oluseun is a recipient of over 10 international awards.",
    profile2:
      "Oluseun Onigbinde chairs the Citizen's Gavel Board and is also a member of the board of trustees for SustyVibes & Eduplana. In 2018, Oluseun Onigbinde was selected by the Obama Foundation for its inaugural Obama Scholars Program at Columbia University.",
    imgpath: oluseun,
  },
  {
    name: "Saratu Abiola",
    title: "Lead, New Economy and Intelligence Unit, BudgIT",
    profile: "",
    profile2: "",
    imgpath: saratu,
  },
  {
    name: "Katja Schiller Nwator",
    title: "Founder and Principal of Motive Point Advisory LLC",
    profile: "",
    profile2: "",
    imgpath: katja,
  },
];

const Leadership = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      padding={{ xs: "30% 0% 5% 0%", sm: "2% 0% 2% 0%" }}
      spacing={1}
    >
      <Grid item xs={12} sm={12}>
        <Box
          width={{ xs: "100%", sm: "60%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={700}
            textAlign={"left"}
            color={"#39484E"}
            paddingBottom={"5%"}
          >
            Fund Managers
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        flexWrap={"wrap"}
        marginTop={"1%"}
      >
        {council.map((advisory, index) => {
          const { name, imgpath, title } = advisory;
          return (
            <Grid>
              <Grid
                key={index}
                item
                xs={12}
                md={4}
                marginBottom={{ xs: "10%", sm: "5%" }}
                marginRight={{ xs: "0%", sm: "1%" }}
                marginLeft={{ xs: "0%", sm: "0%" }}
                display={{ xs: "none", sm: "block" }}
              >
                <Card
                  sx={{
                    minWidth: 380,
                    maxWidth: 380,
                    height: "100%",
                    bgcolor: "#fff",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="350"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#39484E"}
                      fontWeight={700}
                      paddingTop={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"4%"}
                      variant="body1"
                      color="#000"
                      fontWeight={700}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                key={index}
                item
                xs={12}
                md={4}
                marginBottom={{ xs: "10%", sm: "5%" }}
                marginRight={{ xs: "0%", sm: "1%" }}
                marginLeft={{ xs: "0%", sm: "0%" }}
                display={{ xs: "block", sm: "none" }}
              >
                <Card
                  sx={{
                    minWidth: 330,
                    maxWidth: 330,
                    height: "100%",
                    bgcolor: "#fff",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="320"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#39484E"}
                      fontWeight={700}
                      paddingTop={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"4%"}
                      variant="body1"
                      color="#000"
                      fontWeight={700}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Leadership;
